"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const config_1 = require("config");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const CoreContext_1 = require("../../contexts/CoreContext");
const UrlHelper_1 = require("../../helpers/UrlHelper");
const downloadTeamsImg = require("../../images/download_teams_desktop.svg");
const launcherMeetingsImg = require("../../images/launcher_meetings_new2.svg");
const unsupportedBrowserImg = require("../../images/unsupported_browser.svg");
const DownloadState_1 = require("../../models/DownloadState");
const Environment_1 = require("../../models/Environment");
const JoinInfo_1 = require("../../models/JoinInfo");
const TelemetryEvents_1 = require("../../models/telemetry/TelemetryEvents");
const DownloadService_1 = require("../../services/DownloadService");
const Logger_1 = require("../../services/Logger");
const Button_1 = require("../common/Button");
const Footer_1 = require("../common/Footer");
const TeamsLogo_1 = require("../common/TeamsLogo");
const Translate_1 = require("../common/Translate");
const View_1 = require("../common/View");
const DownloadInProgress_1 = require("./DownloadInProgress");
const DownloadPotentiallyCompleted_1 = require("./DownloadPotentiallyCompleted");
const InstallPrompt_1 = require("./InstallPrompt");
require("./joinView.scss");
const HAVING_TROUBLE_TIMEOUT = 2000;
class JoinView extends React.Component {
    constructor(props) {
        super(props);
        this.getHeaderTitle = (environment, downloadBehavior, featureFlags, joinInfo) => {
            if (this.state.havingTroubleEdge) {
                return "hdr_having_trouble";
            }
            if (joinInfo.type !== JoinInfo_1.JoinType.Meetup) {
                return "hdr_welcome2_header";
            }
            const isBroadcast = this.isBroadcast(joinInfo);
            if (isBroadcast) {
                // For producers/presenters coming from Yammer, the primary scenario is joining the meeting and not watching as attendee
                const isYammerBroadcastDeeplink = this.isYammerDeeplink(joinInfo);
                return isYammerBroadcastDeeplink ?
                    "hdr_broadcast_title" : // Join live event
                    "hdr_broadcast_welcome_header"; // Watch the live event in Microsoft Teams
            }
            if (featureFlags.enableLWJ &&
                !environment.isWindows10 &&
                !environment.isWebClientSupportedBrowser &&
                environment.isLWJSupportedBrowser &&
                this.state.pstnIsAvailable) {
                return "hdr_use_windows_or_chrome_header";
            }
            if (featureFlags.enableLWJ &&
                environment.isWindows10 &&
                environment.isLWJSupportedBrowser) {
                return "hdr_use_windows_or_edge_header";
            }
            if (featureFlags.enableLWJ && !downloadBehavior && !environment.isWebClientSupportedBrowser) {
                return "hdr_use_chrome_header";
            }
            return "hdr_welcome_header";
        };
        this.getBrowserSupportSubHeaderTitle = (environment, pstnAvailable = true) => {
            return environment.isLWJSupportedBrowser && pstnAvailable
                ? "hdr_limited_browser_support_header"
                : "hdr_no_browser_support_header";
        };
        this.state = {
            pstnIsAvailable: undefined,
            havingTroubleEdge: false,
        };
    }
    componentDidMount() {
        const { meetingInfo, threadId, messageId } = this.props.joinInfo;
        if (meetingInfo && threadId && messageId !== undefined) {
            fetch(this.getPstnAvailabilityUrl(meetingInfo.tenantId, meetingInfo.organizerId, threadId, messageId))
                .then((value) => {
                return value.json();
            })
                .then((value) => {
                const pstnIsAvailable = !!value.dialinEnabled || !!value.dialoutEnabled;
                this.setPstnIsAvailableState(pstnIsAvailable);
            }).catch(() => {
                this.setPstnIsAvailableState(false);
            });
        }
    }
    renderDownloadButton(downloadBehavior) {
        if (!downloadBehavior) {
            return null;
        }
        return (React.createElement(Button_1.Button, { id: "downloadDesktopClient", className: "primary", onClick: downloadBehavior.onClick },
            React.createElement(Translate_1.Translate, { i18n: downloadBehavior.i18n })));
    }
    renderBody(joinInfo, environment, featureFlags, downloadState, launcherService) {
        const downloadBehavior = DownloadService_1.default.getDownloadBehaviour(joinInfo, environment, featureFlags, launcherService, downloadState);
        switch (downloadState.step) {
            case DownloadState_1.DownloadStep.InProgress:
                if (downloadBehavior) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DownloadInProgress_1.DownloadInProgress, { onDownloadClick: downloadBehavior.onClick }),
                        React.createElement(InstallPrompt_1.InstallPrompt, { browser: environment.browserName })));
                }
            case DownloadState_1.DownloadStep.PotentiallyCompleted:
                if (downloadBehavior) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(DownloadPotentiallyCompleted_1.DownloadPotentiallyCompleted, { onDownloadClick: downloadBehavior.onClick, onLaunchClick: this.props.onLaunchClick, onWebLaunchClick: this.onOpenTeamsInBrowserClick(launcherService) }),
                        React.createElement(InstallPrompt_1.InstallPrompt, { browser: environment.browserName })));
                }
            default:
                return (React.createElement(React.Fragment, null,
                    this.joinView(joinInfo, downloadBehavior, environment, featureFlags, launcherService),
                    environment.isNativeClientSupportedOS && (React.createElement("p", { className: "desktopMessage" },
                        React.createElement("span", null,
                            React.createElement(Translate_1.Translate, { i18n: "hdr_try_again_text" })),
                        "\u00A0",
                        React.createElement("a", { className: "launchLink", id: "tryProtocolLaunchTeamsClient", href: "#", onClick: this.props.onLaunchClick },
                            React.createElement(Translate_1.Translate, { i18n: "hdr_lnk_launch_skype" })))),
                    this.state.havingTroubleEdge && (React.createElement("p", { className: "desktopMessage havingProblems" },
                        React.createElement("span", null,
                            React.createElement(Translate_1.Translate, { i18n: "txt_having_other_problems" })),
                        "\u00A0",
                        React.createElement("a", { className: "launchLink", id: "tryProtocolLaunchTeamsClient", href: "#", onClick: launcherService.redirectToLearnMore },
                            React.createElement(Translate_1.Translate, { i18n: "txt_get_more_help" }))))));
        }
    }
    render() {
        return (React.createElement(View_1.View, { className: "joinView" },
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement(TeamsLogo_1.TeamsLogo, null)),
            React.createElement("div", { className: "body column centered", role: "main" },
                React.createElement(CoreContext_1.CoreContextConsumer, null, ({ environment, featureFlags, launcherService }) => (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo, downloadState }) => (React.createElement(React.Fragment, null,
                    React.createElement("img", { className: "partyImage", id: "party-image", src: this.getIllustrationSrc(joinInfo, environment.isWebClientSupportedBrowser, featureFlags.enableLWJ), "aria-hidden": "true" }),
                    this.renderBody(joinInfo, environment, featureFlags, downloadState, launcherService))))))),
            React.createElement(Footer_1.Footer, null)));
    }
    setPstnIsAvailableState(pstnIsAvailable) {
        const event = new TelemetryEvents_1.PstnJoinAvailable({ pstnIsAvailable });
        Logger_1.default.log(event);
        this.setState({ pstnIsAvailable });
    }
    getPstnAvailabilityUrl(tenantId, organizerId, threadId, messageId) {
        return encodeURI(`${config_1.default.urls.absoluteUrls.pstnCapabilities}/` +
            `${tenantId}/` +
            `${organizerId}/` +
            `${threadId.replace("19:", "19_")}/` +
            messageId);
    }
    joinView(joinInfo, downloadBehavior, environment, featureFlags, launcherService) {
        const isBroadcast = this.isBroadcast(joinInfo);
        const showLWJButton = joinInfo.type === JoinInfo_1.JoinType.Meetup &&
            featureFlags.enableLWJ &&
            environment.isLWJSupportedBrowser &&
            this.state.pstnIsAvailable &&
            !isBroadcast;
        const broadcastYammerAttendee = this.isYammerDeeplink(joinInfo);
        const joinInEdge = (featureFlags.enableLWJ && environment.isLWJSupportedBrowser && joinInfo.type === JoinInfo_1.JoinType.Meetup &&
            environment.isWindows10 && environment.browserName !== Environment_1.Browsers.Edge && !isBroadcast && !this.state.havingTroubleEdge);
        const joinInThisBrowser = !joinInEdge &&
            (featureFlags.enableLWJ && environment.isLWJSupportedBrowser && joinInfo.type === JoinInfo_1.JoinType.Meetup &&
                this.state.pstnIsAvailable && !isBroadcast);
        const joinOnWeb = !joinInEdge && !joinInThisBrowser &&
            (joinInfo.type !== JoinInfo_1.JoinType.Meetup && (environment.isLWJSupportedBrowser || environment.isWebClientSupportedBrowser) ||
                (environment.isWebClientSupportedBrowser && joinInfo.type === JoinInfo_1.JoinType.Meetup && !broadcastYammerAttendee) ||
                (!featureFlags.enableLWJ && environment.isLWJSupportedBrowser && joinInfo.type === JoinInfo_1.JoinType.Meetup && isBroadcast && !broadcastYammerAttendee) ||
                (featureFlags.enableLWJ && environment.isLWJSupportedBrowser && joinInfo.type === JoinInfo_1.JoinType.Meetup && (!isBroadcast && this.state.pstnIsAvailable || isBroadcast && !broadcastYammerAttendee)));
        /*
        // tslint:disable-next-line: no-console
        console.log(`FF joinOnWeb: ${joinOnWeb}, joinInEdge: ${joinInEdge}, joinInThisBrowser: ${joinInThisBrowser}`);
        // tslint:disable-next-line: no-console
        console.log(`Reason: isWebClientSupportedBrowser: ${environment.isWebClientSupportedBrowser} (Edge or Chrome), isMeetup: ${joinInfo.type === JoinType.Meetup}, LWJff: ${featureFlags.enableLWJ}, isLWJSupportedBrowser: ${environment.isLWJSupportedBrowser}, isBroadcast: ${isBroadcast}, isYammerBroadcast: ${broadcastYammerAttendee}, win10: ${environment.isWindows10}, Edge: ${environment.browserName === Browsers.Edge}, pstn: ${this.state.pstnIsAvailable} `);
        */
        return (React.createElement(React.Fragment, null,
            featureFlags.enableLWJ &&
                joinInfo.type === JoinInfo_1.JoinType.Meetup &&
                !isBroadcast &&
                (environment.isLWJSupportedBrowser && !environment.isWebClientSupportedBrowser) &&
                !this.state.havingTroubleEdge && (React.createElement("p", { className: "noSupport" },
                React.createElement(Translate_1.Translate, { i18n: this.getBrowserSupportSubHeaderTitle(environment, this.state.pstnIsAvailable) }))),
            React.createElement("h1", { id: "join-prompt-header", className: "title" },
                React.createElement(Translate_1.Translate, { i18n: this.getHeaderTitle(environment, downloadBehavior, featureFlags, joinInfo) })),
            this.state.havingTroubleEdge && (React.createElement("p", { className: "tryEdgeAgain" },
                React.createElement("a", { className: "launchLink", href: "#", onClick: this.onOpenTeamsInEdgeClick(launcherService) },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_lnk_try_joining_edge_again" })))),
            React.createElement("div", { className: "buttonsContainer" },
                this.renderDownloadButton(downloadBehavior),
                joinOnWeb && (React.createElement(Button_1.Button, { "data-tid": "joinOnWeb", id: "openTeamsClientInBrowser", onClick: this.onOpenTeamsInBrowserClick(launcherService) },
                    React.createElement(Translate_1.Translate, { i18n: isBroadcast
                            ? "hdr_watch_broadcast_btn"
                            : joinInfo.type === JoinInfo_1.JoinType.Meetup ?
                                "hdr_btn_join_on_web"
                                : "hdr_btn_launch_open_teams" }))),
                joinInThisBrowser && (React.createElement(Button_1.Button, { "data-tid": "joinInBrowser", id: "openTeamsClientInBrowser", onClick: this.onOpenTeamsInBrowserClick(launcherService) },
                    React.createElement("div", { className: "tooltip" },
                        React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_this_browser_tooltip" })),
                    React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_this_browser" }))),
                joinInEdge && (React.createElement(Button_1.Button, { "data-tid": "joinInEdge", id: "openTeamsClientInEdge", onClick: this.onOpenTeamsInEdgeClick(launcherService) },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_edge" }))),
                featureFlags.enableLWJ &&
                    (environment.isLWJSupportedBrowser ||
                        !environment.isWebClientSupportedBrowser &&
                            !environment.isLWJSupportedBrowser) &&
                    (!this.state.pstnIsAvailable || !showLWJButton) &&
                    !environment.isNativeClientSupportedOS && (React.createElement(Button_1.Button, { id: "learnMore", onClick: launcherService.redirectToLearnMore },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_btn_learn_more" })))),
            joinInEdge && this.state.pstnIsAvailable && (React.createElement("p", { className: "desktopMessage" },
                React.createElement("a", { id: "joinInThisBrowser", className: "launchLink", href: "#", onClick: this.onOpenTeamsInBrowserClick(launcherService) },
                    React.createElement("div", { className: "tooltip" },
                        React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_this_browser_tooltip" })),
                    React.createElement(Translate_1.Translate, { i18n: "hdr_btn_join_in_this_browser" }))))));
    }
    onOpenTeamsInEdgeClick(launcherService) {
        return () => {
            launcherService.redirectToWebJoin(undefined, true);
            window.setTimeout(() => {
                this.setState({ havingTroubleEdge: true });
            }, HAVING_TROUBLE_TIMEOUT);
        };
    }
    onOpenTeamsInBrowserClick(launcherService) {
        return () => launcherService.redirectToWebJoin();
    }
    getIllustrationSrc(joinInfo, isSupportedBrowser, enableLWJ) {
        if (joinInfo.type === JoinInfo_1.JoinType.Meetup) {
            return isSupportedBrowser || !enableLWJ || this.isBroadcast(joinInfo)
                ? launcherMeetingsImg
                : unsupportedBrowserImg;
        }
        else {
            return downloadTeamsImg;
        }
    }
    isYammerDeeplink(joinInfo) {
        const sourceParam = UrlHelper_1.UrlHelper.getQueryParameter("lmsrc", joinInfo.conversationUrl);
        return !!sourceParam && sourceParam.toLowerCase() === "yammer";
    }
    isBroadcast(joinInfo) {
        return joinInfo.meetingInfo && joinInfo.meetingInfo.isBroadcast || false;
    }
}
exports.JoinView = JoinView;
